import { UIProvider as BaseUIProvider } from '@99designs/emu';
import { formatMessage } from '@99designs/frontend-components/i18n';

// This component reimplements the UIProvider at a slightly lower level than _app.
// This is due to the `__` function being initialised by a shim in a separate context.
// If the UIProvider is declared 'above' the I18nProvider in `_app`, `__` will not be declared
// when the `_app` tries to render.
export const UIProvider = ({ children }: { children: React.ReactNode }) => {
    return (
        <BaseUIProvider
            translationStrings={{
                Alert: {
                    Dismiss: __('Dismiss'),
                },
                ButtonGroup: {
                    Menu: __('More options'),
                },
                Modal: {
                    Close: __('Close'),
                },
                Rating: {
                    Legend: __('Rating'),
                    ReadOnlyLabel: (value: number) =>
                        formatMessage(__('{value} out of 5 stars'), {
                            value,
                        }),
                    Value: (value: number) =>
                        value === 1
                            ? __('1 star')
                            : formatMessage(__('{value} stars'), {
                                  value,
                              }),
                },
                Select: {
                    ClearAll: __('Clear all'),
                    Open: __('Open'),
                    Remove: __('Remove'),
                },
                Pagination: {
                    Next: __('Next'),
                    Previous: __('Previous'),
                },
            }}
        >
            {children}
        </BaseUIProvider>
    );
};
